import WS from "../../../../utility/webSocket";
import Model from "./model"
import errorDialog from "@/views/ErrorDialog/errorDialog";
import ApiImport from "@/api/integration/import";
import { $t } from "@/i18n";

export default class Controller {
    constructor(onWsMessage, importSessionId) {
        this.model = new Model(importSessionId)
        this._onWsMessage = onWsMessage
        this.constructWebSocket()
    }

    constructWebSocket() {
        this.webSocket = new WS(this._onWsMessage, "/ws/import")
    }

    closeWebSocket() {
        this.webSocket.close()
    }

    addStaticField(field) {
        this.model.addStaticField(field)
    }

    removeStaticField(uku_key) {
        this.model.removeStaticField(uku_key)
    }

    mapped_column_changed(column, uku_key) {
        this.model.mapped_column_changed(column, uku_key)
    };

    async nextStep() {
        this.model.getLoader().setForceLoading(true)
        const self = this;

        this.webSocket.connect(async () => {
            try {
                await ApiImport.saveImportSettings(this.model.getExcelSaveData())
            } catch (e) {
                errorDialog.showError(e)
                self.webSocket.close()
                self.model.getLoader().setForceLoading(false)
                // ability to retry after an exception is reported from backend
                self.constructWebSocket()
            }
        }, () => {
            errorDialog.showError($t("Failed to connect to server"))
            self.model.getLoader().setForceLoading(false)
        })
    }

    async loadData() {
        try {
            const response = await ApiImport.getImportSession(this.model.getImportSessionId(), true, true)

            this.model.setCompanyId(response.import_session.account_id)
            this.model.setImportFields(response.import_mapping.fields)
            this.model.setPreviewData(response.preview_data)
            this.model.setFile(response.import_session.file)

            if (response.import_session.settings && response.import_session.settings.mapped_fields && response.import_session.settings.mapped_fields.length) {
                this.model.mappedFields = response.import_session.settings.mapped_fields.filter(x => x.uku_key !== 'import_client_id')
            } else {
                this.model.setMappedFieldsFromRowHeader()
            }

        } catch (e) {
            errorDialog.showError(e)
        }
    }

    openAddCustomFieldDialog() {
        this.model.setShowAddCustomFieldDialog(true)
    }

    closeAddCustomFieldDialog() {
        this.model.setShowAddCustomFieldDialog(false)
    }

    async updateCustomFields() {
        try {
            const data = await ApiImport.getImportSession(this.model.getImportSessionId(), false, true)
            this.model.setImportFields(data.import_mapping.fields)
        } catch (e) {
            errorDialog.showError(e)
        }
    }
}